import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { FuncionalidadesService } from '../../../_services/funcionalidades.service';
import { ListaService } from '../../../_services/lista.service';
import { Convenio } from '../../../_models/convenio';
import moment from 'moment';
import 'moment/locale/es';
import { ConvenioService } from '../../../_services/convenio.service';
import { Location } from '@angular/common';
import { CalendarioInformacion } from '../../../_models/calendario-informacion';

@Component( {
  selector: 'app-convenios-editar',
  templateUrl: 'convenios-editar.component.html'
} )
export class ConveniosEditarComponent implements OnInit {

  //
  codigos: any[] = [];
  refrescar: EventEmitter<boolean> = new EventEmitter<boolean>();

  //
  formulario: FormGroup;
  submitted = false;
  es: any;
  range = '';
  configModel = {
    fechaInicioMin: null,
    fechaInicioMax: null,
    fechaFinMin: null,
    fechaFinMax: null,
    numeroContrato: ''
  };
  opcionesDesembolsos: any[] = [];
  guardando = false;
  model: Convenio = null;
  private codigoValido = true;


  constructor(
    private router: Router,
    private navService: NavService,
    private autServicio: AutenticacionService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private convenioService: ConvenioService,
    private funServicio: FuncionalidadesService,
    private location: Location,
    private listaService: ListaService,
  ) {
  }

  ngOnInit() {

    // Config Calendario
    this.range = `${(new Date().getFullYear()) - 20}:${(new Date().getFullYear()) + 50}`;
    this.es = new CalendarioInformacion();

    // Buscar Lista
    this.listaService.getMasterDetails( 'ListasOpcionesDesembolsos' )
      .subscribe( res => {
        res.forEach( x => this.opcionesDesembolsos.push( { value: x.idLista, label: x.nombre } ) );
      } );

    this.convenioService.listado()
      .subscribe( x => {
        this.codigos = x.map( y => y.numeroContrato );
      } );

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.convenioService.obtenerPorId( params[ 'id' ] ).subscribe( convenio => this.cargarFormulario( convenio ) );
      } else {
        this.cargarFormulario( null );
      }
    } );

  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario( model?: Convenio ) {
    this.model = model;
    this.formulario = this.fb.group( {
      idConvenio: [ this.model ? this.model.idConvenio : null, [] ],
      numeroContrato: [ this.model ? this.model.numeroContrato : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.model ? this.model.nombre : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      fechaDesde: [ this.model ? this.model.fechaDesde : null, [ Validators.required ] ],
      fechaHasta: [ this.model ? this.model.fechaHasta : null, [ Validators.required ] ],
      idOpcionDesembolso: [ this.model ? this.model.idOpcionDesembolso : null, [ Validators.required ] ],
      indicadorHabilitado: [ !this.model || this.model.indicadorHabilitado, [ Validators.required ] ]
    } );
    if ( this.model ) {
      this.configModel.fechaFinMin = moment( this.model.fechaDesde, 'YYYY-MM-DD' ).toDate();
      this.configModel.numeroContrato = this.model.numeroContrato;
    }
  }

  cancelar() {
    if ( this.formulario.dirty ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'convenios',
        icon: 'fa fa-question-circle',
        accept: () => this.location.back(),
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  guardarFechaDesde( event: any ) {
    this.f.fechaDesde.setValue( moment( event ).format( 'YYYY-MM-DD' ) );
    this.f.fechaHasta.setValue( null );
    this.configModel.fechaFinMin = moment( event, 'YYYY-MM-DD' ).toDate();
  }

  guardarFechaHasta( event: any ) {
    this.f.fechaHasta.setValue( moment( event ).format( 'YYYY-MM-DD' ) );
  }

  validarUnicoCodigo( value ) {
    this.codigoValido = this.codigos
      .find( x => x === value
        && (this.configModel.numeroContrato.length === 0
          || this.configModel.numeroContrato !== value)
      ) === undefined;
  }

  guardar() {
    this.submitted = true;
    if ( this.formulario.invalid || !this.codigoValido ) {
      return;
    }
    if ( this.f.idConvenio.value ) {
      this.convenioService.crear( this.formulario.value )
        .subscribe( res => {
          this.location.back();
        } );
    } else {
      this.convenioService.actualizar( this.formulario.value )
        .subscribe( res => {
          this.location.back();
        } );
    }
  }

}
